import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import clubs from "./modules/clubs-module";
import telecoms from "./modules/telecoms-module";
import services from "./modules/services-module";
import members from "./modules/members-module";
import archived_members from "./modules/archived-members-module";
import member_services from "./modules/member-services-module";
import member_categories from "./modules/member-categories-module";
import member_notes from "./modules/member-notes-module";
import people from "./modules/people-module";
import contacts from "./modules/contacts-module";
import organizations from "./modules/organizations-module";
import banks from "./modules/banks-module";
import tasks from "./modules/tasks-module";
import statistics from "./modules/statistics-module";
import invoices from "./modules/invoices-module";
import dates from "./modules/dates-module";

Vue.use(Vuex);
// TODO: Cleanup: Remove restore-functions

export default new Vuex.Store({
  modules: {
    auth,
    alerts,
    profile,
    users,
    roles,
    clubs,
    telecoms,
    services,
    members,
    archived_members,
    member_notes,
    member_services,
    member_categories,
    people,
    contacts,
    organizations,
    banks,
    tasks,
    statistics,
    invoices,
    dates
  }
});
